import React from 'react';
import styled from 'styled-components';

import ProductCard from './ProductCard';

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

function ProductListItems({
  items,
  bold,
  color,
  size,
  search_params = '',
  item_count = '0',
  page = '0'
}) {
  return (
    <Container>
      {items
        ? items.map((data, i) => (
            <ProductCard key={i} productData={data} bold={bold} size={size} color={color} />
          ))
        : null}
    </Container>
  );
}

export default ProductListItems;
